import api from "./api"

export const getAddrTreeAPI = async () => {
  const { data } = await api.get(`/api/apt`)
  return data
}

export const getAptSearchAPI = async ({ addr_codes, keyword }) => {
  const { data } = await api.post("/api/apt/search-batch", {
    addr_codes,
    keyword
  })
  return data
}

export const getSidoByIdsAPI = async (kapt_codes) => {
  const { data } = await api.post("/api/apt/by-ids", {
    kapt_codes
  })

  return data
}

export const getAptByPathAPI = async ({ kapt_code }) => {
  const { data } = await api.get(`/api/apt/by-path`, {
    params: { kapt_code }
  })
  return data
}

// INFO: 동별 호 데이터 정보
export const getDongHoInfoAPI = async ({ kapt_code }) => {
  const { data } = await api.get(`/api/apt/${kapt_code}/dongho-info`)

  return data
}

// INFO: 동별 호의 개수
export const getDonghoCountAPI = async ({ kapt_code }) => {
  const { data } = await api.get(`/api/apt/${kapt_code}/dongho-count`)
  return data
}

// INFO: 동별 호 사이즈 정보
export const getAptSizeMapAPI = async ({ kapt_code }) => {
  const { data } = await api.get(`/api/apt/${kapt_code}/unit-sizes`)
  return data
}
